<p-carousel
  class="border-round-md overflow-hidden"
  #carousel
  [value]="teaserItems"
  [showNavigators]="false"
  [showIndicators]="teaserItems.length > 1"
  [numVisible]="1"
  [autoplayInterval]="autoplayIntervall"
  [numScroll]="1">
  <ng-template let-item pTemplate="item">
    <div
      class="h-full w-full p-3 pb-6 flex justify-content-center flex-column bg-cover bg-center bg-no-repeat"
      [style]="
        'background-color:' +
        (item.backgroundColor || 'transparent') +
        '; background-image: url(' +
        item.backgroundSrc +
        ')'
      ">
      <div
        class="p-card bg-white-alpha-80 p-3 mb-3 overflow-auto"
        style="max-height: 75%">
        <header class="mb-3">
          <span class="text-xs">{{ item.topmark }}</span>
          <h3>
            {{
              removeHtmlFromString(item.header) ||
                'Konfigurieren Sie Ihren Teaser in der Sidebar'
            }}
          </h3>
        </header>
        @if (item.content) {
          <div [innerHTML]="item.content"></div>
        }
      </div>
      @if (item.bookmark && bookmarkStore.getById(item.bookmark); as bookmark) {
        <app-bookmark-button
          class="mb-2"
          [bookmark]="bookmark"></app-bookmark-button>
      }
      @if (item.href) {
        <a
          target="_blank"
          icon="fas fa-external-link-square"
          class="w-auto ml-auto mr-auto no-underline"
          pButton
          [href]="item.href"
          [label]="item.linkCaption || 'weiterlesen'"
          [rounded]="true"></a>
      }
    </div>
  </ng-template>
</p-carousel>
